import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

export interface Server {
  type: ServerType;
  url: string;
}

export enum ServerType {
  AUTH,
  USER,
  WALLET,
  PRICE,
  SHIPMENT,
  PRODUCT,
  STRIPE,
  NOTIFICATION,
  CONFIGURATION
}

@Injectable({
  providedIn: "root",
})
export class AppInitService {
  serverList = [];

  SELF_URL: string;

  constructor() {}

  Init() {
    return new Promise<void>((resolve, reject) => {
      const urlItem = environment.urls.find((u) => u.self == location.hostname);
      this.serverList.push({ type: ServerType.AUTH, url: urlItem.auth });
      this.serverList.push({ type: ServerType.USER, url: urlItem.user });
      this.serverList.push({ type: ServerType.WALLET, url: urlItem.wallet });
      this.serverList.push({ type: ServerType.PRICE, url: urlItem.price });
      this.serverList.push({
        type: ServerType.SHIPMENT,
        url: urlItem.shipment,
      });
      this.serverList.push({ type: ServerType.PRODUCT, url: urlItem.product });
      this.serverList.push({ type: ServerType.STRIPE, url: urlItem.stripe });
      this.serverList.push({type: ServerType.CONFIGURATION, url: urlItem.configuration});
      this.serverList.push({
        type: ServerType.NOTIFICATION,
        url: urlItem.notification,
      });
      this.SELF_URL = `https://${urlItem.self}/`;
      resolve();
    });
  }
}
